import Image from "next/image";
import { useRouter } from "next/router";
import CrossReferenceComponent from "../../../components/Search/CrossReferenceComponent";
import CupSearchComponent from "../../../components/Search/CupSearchComponent";
import NavTabButton from "../../../components/Search/NavTabButton";
import PartSearchComponent from "../../../components/Search/PartSearchComponent";
import RegoSearchComponent from "../../../components/Search/RegoSearchComponent";
import SearchBreadcrumbComponent from "../../../components/Search/SearchBreadcrumbComponent";
import VehicleSearchComponent from "../../../components/Search/VehicleSearchComponent";
import Footer from "../../../components/_App/Footer";
import Header from "../../../components/_App/Header";
import apiClient from "../../../data/apiClient";
import { FOOTER_QUERY } from "../../../data/pageQuery";
import { GoogleReCaptchaProvider,  useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useEffect, useState } from "react";

const SearchPage = ({ currentTab, slug, state, seo, menu, footer }) => {
  // const { executeRecaptcha } = useGoogleReCaptcha();
  const router = useRouter();
  const title = `${state}/${slug}`;
  const [location,setLocation]=useState(state);
  const [newSlag,setNewSlag]=useState(slug);
  useEffect(()=>{

  },[]);
  let breadTitle = "By Reg or VIN";

  switch (currentTab) {
    case 0:
      break;
    case 1:
      breadTitle = "By Vehicle Type";
      break;
    case 2:
      breadTitle = "By Xref";
      break;
    case 3:
      breadTitle = "By Part No";
      break;
    case 4:
      breadTitle = "By CUP No";
      break;
    default:
      break;
  }

  const syncChange = (sync) => {
    if (currentTab !== sync) {
      if (sync === 0) {
        router.push("/search/-/-");
      } else if (sync === 1) {
        router.push("/search/type/-");
      } else if (sync === 2) {
        router.push("/search/xref/-");
      } else if (sync === 3) {
        router.push("/search/part/-");
      } else if (sync === 4) {
        router.push("/search/cup/-");
      }
    }
  };

  const isActiveTab = (id) => {
    return currentTab === id;
  };

  return (
    <>
      <Header {...menu} />
      {/* <GoogleReCaptchaProvider
        reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      > */}
      <div className='page-wrapper flex-grow-1'>
        <div className='w-100 d-flex bg-light py-md-4 py-3'>
          <SearchBreadcrumbComponent title={breadTitle} />
        </div>
        {/* tab navigation */}
        <div className={`BannerTabs section-sm-bottom`}>
          <div className='mb-3 mb-lg-5 container-fluid p-md-0'>
            <div className='row g-0'>
              <div className='col-12 overflow-auto'>
                <ul
                  className='nav nav-tabs custom-tabs justify-content-md-center text-nowrap flex-nowrap'
                  id='searchTabs'
                  role='tablist'
                  aria-owns='regofvin-tab vehicletype-tab partnumber-tab cup-tab'
                >
                  <NavTabButton
                    caption={"Rego or vin"}
                    tabId={0}
                    isActive={isActiveTab}
                    onClick={syncChange}
                  />
                  <NavTabButton
                    caption={"vehicle type"}
                    tabId={1}
                    isActive={isActiveTab}
                    onClick={syncChange}
                  />
                  <NavTabButton
                    caption={"cross ref"}
                    tabId={2}
                    isActive={isActiveTab}
                    onClick={syncChange}
                  />
                  <NavTabButton
                    caption={"part number"}
                    tabId={3}
                    isActive={isActiveTab}
                    onClick={syncChange}
                  />
                  <NavTabButton
                    caption={"cup"}
                    tabId={4}
                    isActive={isActiveTab}
                    onClick={syncChange}
                  />
                </ul>
              </div>
            </div>
          </div>
          <div className='tab-content'>
            <div
              className={`tab-pane fade show container pb-md-5 pb-3 ${
                currentTab === 0 ? "active show" : ""
              }`}
            >
           <RegoSearchComponent state={location} regoOrVin={newSlag}  />
           
            </div>
            {currentTab === 0 && (
              <div className='d-flex justify-content-end p-2'>
                <Image
                  width='99'
                  height='36'
                  alt='Autoinfo'
                  src='/img/auto-info.svg'
                  layout='raw'
                />
              </div>
            )}
            <div
              className={`tab-pane fade ${
                currentTab === 1 ? "active show" : ""
              }`}
            >
              <VehicleSearchComponent/>
            </div>
            {currentTab === 1 && (
              <div className='d-flex justify-content-end p-2'>
                <Image
                  width='99'
                  height='36'
                  alt='Autoinfo'
                  src='/img/auto-info.svg'
                  layout='raw'
                />
              </div>
            )}
            <div
              className={`tab-pane fade pb-md-5 pb-3 ${
                currentTab === 2 ? "active show" : ""
              }`}
            >
              <CrossReferenceComponent />
            </div>
            <div
              className={`tab-pane fade pb-md-5 pb-3 ${
                currentTab === 3 ? "active show" : ""
              }`}
            >
              <PartSearchComponent />
            </div>
            <div
              className={`tab-pane fade pb-md-5 pb-3 ${
                currentTab === 4 ? "active show" : ""
              }`}
            >
              <CupSearchComponent />
            </div>
          </div>
        </div>
      </div>
      {/* </GoogleReCaptchaProvider> */}
      <Footer {...footer} />
    </>
  );
};

export async function getServerSideProps({ params }) {
  const { state = "", slug = "" } = params;
  let currentTab = 0;
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  let notFound = false;

  notFound = state === "" || slug === "";

  if (isAU) {
    switch (state.toUpperCase()) {
      case "-":
      case "NSW":
      case "VIC":
      case "ACT":
      case "QLD":
      case "SA":
      case "NT":
      case "WA":
      case "TAS":
      case "NHV":
      case "VIN":
        break;
      case "TYPE":
        currentTab = 1;
        break;
      case "XREF":
        currentTab = 2;
        break;
      case "PART":
        currentTab = 3;
        break;
      case "CUP":
        currentTab = 4;
        break;
      default:
        notFound = true;
        break;
    }
  } else {
    switch (state.toUpperCase()) {
      case "-":
      case "NZ":
      case "VIN":
        break;
      case "TYPE":
        currentTab = 1;
        break;
      case "XREF":
        currentTab = 2;
        break;
      case "PART":
        currentTab = 3;
        break;
      case "CUP":
        currentTab = 4;
        break;
      default:
        notFound = true;
        break;
    }
  }

  try {
    const { data } = await(await apiClient()).query({
      query: FOOTER_QUERY,
      variables: {},
      fetchPolicy: "cache-first",
    });

    const {
      queryFooterContents: footerContents,
      queryMenuContents: menuContents,
    } = data;

    const footerContent =
      footerContents[0] != null ? footerContents[0].flatData : [];
    const menuContent = menuContents[0] != null ? menuContents[0].flatData : [];

    return {
      props: {
        slug: params.slug,
        state: params.state,
        footer: footerContent,
        menu: menuContent,
        currentTab: currentTab,
        seo: {
          title: `Application Search | Ryco Filters | Air Filters, Oil Filters and Fuel Filters | Automotive Filters`,
          metadata: `Application Search`,
          keywords: "Ryco Application Search",
          pic: null,
          socialTitle: `Application Search | Ryco Filters | Air Filters, Oil Filters and Fuel Filters | Automotive Filters`,
        },
      },
    };
  } catch (error) {
    console.log("page loading error", error);
  }
}

export default SearchPage;
